import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import {Redirect} from "react-router";
import {ErrorMessage, Field, Form, Formik} from "formik";
import ErrorAlert from "../../../components/UI/ErrorAlert";
import AppContext from "../../../contexts/AppContext";

class ResetPassword extends Component {

    static contextType = AppContext;

    constructor(props) {
        super(props);

        this.state = {
            data: {
                password: '',
                password_confirmation: '',
            },
            token: '',
            email: '',
            status: {},
            redirectToIdentPrisijungti: false,
        };

        this.formSubmit = this.formSubmit.bind(this);
        this.renderForm = this.renderForm.bind(this);
    }

    componentDidMount() {
        const {match: {params}} = this.props;

        this.setState({token: params.token});
        this.setState({email: params.email});
    }

    formSubmit(values, actions) {

        const {clearError} = this.context;
        clearError();

        actions.setStatus({});

        values.token = this.state.token;
        values.email = this.state.email;

        axios.post('/api/user/reset_password', values)
            .then(
                data => {
                    actions.setSubmitting(false);

                    if (data.data.status === 'success') {
                        actions.setStatus({msg: data.data.message});

                        this.setState({redirectToIdentPrisijungti: true});
                    }
                },
                error => {
                    let response_data = error.response.data;

                    actions.setSubmitting(false);
                    actions.setErrors(response_data.errors);
                }
            )
            .catch((a, b, c) => {
                actions.setSubmitting(false);
                console.log(a, b, c);
            });
    }

    render() {
        if (this.state.redirectToIdentPrisijungti) {
            window.location.href = "https://inbank.lt/ident/prisijungti";
            return null;
        }

        return (
            <div>

                <header className="text-white bg-primary-dark heading-block">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <h1 className="heading-block__header">{this.props.t('forms.reset_password')}</h1>
                            </div>
                        </div>
                    </div>
                </header>

                <div className="section window-layout">
                    <div className="container frame">
                        <div className="row">
                            <div className="col-12 my-4 mx-4">
                                <div className="w-75 ml-auto mr-auto">
                                    <ErrorAlert/>
                                </div>
                                <Formik
                                    initialValues={this.state.data}
                                    onSubmit={this.formSubmit}
                                    render={this.renderForm}
                                />

                                {this.state.status && this.state.status.msg && <div>{this.state.status.msg}</div>}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        )
    }

    renderForm(props) {

        return (

            <Form className="form form-layout mt-5 pb-2">
                <div className="container form-layout__2-col">
                    <p>{this.props.t('forms.reset_password_explanation')}</p>

                    <div className="form-group col-12">
                        <label className="form-label" htmlFor="password">{this.props.t('forms.password')}</label>
                        <Field type="password" name="password" id="password" autoComplete={'current-password'}
                               className={'form-control' + (props.errors.password && props.touched.password ? ' is-invalid' : '')}/>
                        <ErrorMessage name="password" component="div" className="invalid-feedback"/>
                    </div>

                    <div className="form-group col-12">
                        <label className="form-label"
                               htmlFor="password_confirmation">{this.props.t('forms.password_confirmation')}</label>
                        <Field type="password" name="password_confirmation" id="password_confirmation" autoComplete={'current-password'}
                               className={'form-control' + (props.errors.password_confirmation && props.touched.password_confirmation ? ' is-invalid' : '')}/>
                        <ErrorMessage name="password_confirmation" component="div" className="invalid-feedback"/>
                    </div>

                    {props.status && props.status.msg && <div>{props.status.msg}</div>}

                    <div className="form-group col-12">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={props.isSubmitting}
                        >
                            {this.props.t('forms.continue_btn')}
                        </button>
                    </div>
                </div>
            </Form>
        );
    }
}

export default withTranslation()(ResetPassword);
